<div class="grid-container padding-y-4">
    <div class="grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <div class="usa-legend usa-legend--large">Bid Cycle Name: {{rateBidCycleName}}</div>
        </div>
    </div>
    <div class="grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <tabset class="maxw-full">
                <tab heading="FRT View Rates" id="tab1" (selectTab)="onSelectTab($event)">
                    <app-frt-rates-download *ngIf="this.activeTab === 'zero' || showViewRate"></app-frt-rates-download>
                </tab>
                <tab heading="FRT Template Download" id="tab2" (selectTab)="onSelectTab($event)">
                    <app-frt-template-download *ngIf="this.activeTab === 'one'"></app-frt-template-download>
                </tab>
                <tab heading="FRT Upload Rate File" id="tab3" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
                    <app-upload *ngIf="this.activeTab === 'two'" [businessType]="'frt'"></app-upload>
                </tab>
                <tab heading="FRT Edit Rates" id="tab4" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
                    <app-frt-rate-edit *ngIf="this.activeTab === 'three'"></app-frt-rate-edit>
                </tab>
                <tab heading="FRT Global Update" id="tab5" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
                    <app-frt-rate-global-update *ngIf="this.activeTab === 'four'"></app-frt-rate-global-update>
                </tab>
            </tabset>
        </div>
    </div>
</div>
